import React, { useEffect, useState } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import BannerCarousel from "../components/BannerCarousel";
import ReactPlayer from "react-player/lazy";
import HTMLReactParser from "html-react-parser";
import axios from "axios";

export default function Header({swmcLink}) {
  const [buffyEpisodeJSONObject, setBuffyEpisodeJSONObject] = useState();
  const [eventHeading, setEventHeading] = useState("");

  // useEffect(() => {
  //   //get buffy the rate slayer episode details
  //   axios
  //     .get(process.env.REACT_APP_BUFFY_LATEST_EPISODE_JSON, {
  //       headers: { 'Content-Type': 'application/json' },
  //     })
  //     .then((response) => {
  //       let buffyEpisodeJson = response.data;
  //       let buffyEventJson;
  //       setBuffyEpisodeJSONObject(buffyEpisodeJson);
  //       //get buffy the rate slayer event details
  //       axios
  //       .get(process.env.REACT_APP_BUFFY_EVENT_HEADING_JSON, {
  //         headers: { 'Content-Type': 'application/json' },
  //       })
  //       .then((response) => {
  //         if (response.data) {
  //           buffyEventJson = response.data;
  //         }

  //         const defaultHeading = "<h2>Here's your fuel for better decisions!</h2>";
  //         let dynamicHeading = defaultHeading;

  //         if (buffyEpisodeJson.eventHeading) {
  //           dynamicHeading = buffyEpisodeJson.eventHeading;
  //         } else if (buffyEventJson.eventHeading) {
  //           dynamicHeading = buffyEventJson.eventHeading;
  //         }

  //         if (dynamicHeading) {
  //           setEventHeading(HTMLReactParser(dynamicHeading));
  //         }
  //       });

  //       return response;
  //     });
  // }, []);

  return (
    <Container fluid id="header-wrapper">
      {/* <Row className="justify-content-center">
        <Col xs={8} md={5} lg={4} className="mt-5">
          <a href="https://www.swmc.com" target="_blank" rel="noreferrer">
            <Image
              src="https://resources.swmc.com/swmc-images/sunwest-trust-white-logo.png"
              fluid
              alt="Sun West Mortgage Logo"
              className="sunwestlogo"
            />
          </a>
        </Col>
      </Row> */}

      <Row className="justify-content-center">
        <Col md={12} lg={12} xl={12}>
          <div className="text-center">
            <h1 className="break">Be Yourself and Be Free at {HTMLReactParser(swmcLink)}</h1>
            <p className="freedom">
              Earn Exceptional Commissions With The Best
            </p>
            <p className="freedom1">“Can-Do” Team Support!</p>
            <p className="freedommobile">
              Earn Exceptional Commissions With <br></br>The Best “Can-Do” Team
              Support!
            </p>
          </div>
          {/* <div className="player-wrapper">
              <ReactPlayer
                className="react-player"
                url={buffyEpisodeJSONObject.url}
                width="100%"
                height="100%"
                light={buffyEpisodeJSONObject.thumbnail}
                playing
                controls
              />
            </div> */}
        </Col>
        {/* <div>
            <BannerCarousel />
          </div> */}
      </Row>
      <Row>
        <Col xl={12} lg={12}>
          <BannerCarousel />
        </Col>
      </Row>
    </Container>
  );
}
